import { render, staticRenderFns } from "./V2PriceBooksModal.vue?vue&type=template&id=0c6144fa&scoped=true&"
import script from "./V2PriceBooksModal.vue?vue&type=script&lang=js&"
export * from "./V2PriceBooksModal.vue?vue&type=script&lang=js&"
import style0 from "./V2PriceBooksModal.vue?vue&type=style&index=0&id=0c6144fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6144fa",
  null
  
)

export default component.exports